import React from 'react';
import {Input as InputStyled} from '../../../assets/styles/GlobalStyles';

export const Input = ({field, form, ...props}) => {
  return <InputStyled {...field} {...props} autoComplete="off" />;
};
